module.exports = __webpack_public_path__ + "static/media/1020895.f6dfd749.png";